import { transformInputToGeocoding } from '../'

export const getGeocodingDataFromInput = async ({ input, token }) => {
  const data = await transformInputToGeocoding(input, token)

  if (data.results.length > 1) return { suggestedAddresses: data.results }
  if (data.results.length === 0) return null
  return data.results[0]
}
